import { ProjectInfo as ProjectInfoGeneral } from '../../project/models/project-info.model';

export class ProjectInfo extends ProjectInfoGeneral {
  rdId: string;

  constructor(info?: any) {
    info = info || {};

    super(info);

    this.rdId = info.rdId || null;
  }
}
